export default [
  {
    path: "marcom",
    name: "marcom",
    component: () => import("@/views/adminPanel/pages/marcom/Marcom.vue"),
    meta: {
      rule: "editor",
    },
  },
  {
    path: "marcom/sms-campaign",
    name: "SMS-Campaign",
    component: () =>
      import("@/views/adminPanel/pages/marcom/components/sms/Sms.vue"),
    meta: {
      rule: "editor",
    },
  },

  {
    path: "marcom/pushNotification-campaign",
    name: "pushNotification-Campaign",
    component: () =>
      import(
        "@/views/adminPanel/pages/marcom/components/pushNotification/PushNotification.vue"
      ),
    meta: {
      rule: "editor",
    },
  },
  {
    path: "marcom/email-campaign",
    name: "email-Campaign",
    component: () =>
      import("@/views/adminPanel/pages/marcom/components/email/Email.vue"),
    meta: {
      rule: "editor",
    },
  },

  {
    path: "marcom/whatsapp-campaign",
    name: "whatsapp-Campaign",
    component: () =>
      import(
        "@/views/adminPanel/pages/marcom/components/whatsapp/Whatsapp.vue"
      ),
    meta: {
      rule: "editor",
    },
  },

  {
    path: "marcom/success",
    name: "successPaymentPage",
    component: () =>
      import(
        "@/views/adminPanel/pages/payment/Success.vue"
      ),
    meta: {
      rule: "editor",
    },
  },

  {
    path: "marcom/failure",
    name: "failurePaymentPage",
    component: () =>
      import(
        "@/views/adminPanel/pages/payment/Failed.vue"
      ),
    meta: {
      rule: "editor",
    },
  },

  {
    path: "marcom/segment",
    name: "marcom-Segment",
    component: () => import("@/views/adminPanel/pages/segment/Segment.vue"),
    meta: {
      rule: "editor",
    },
  },

  {
    path: "marcom/templates",
    name: "marcom-Templates",
    component: () =>
      import("@/views/adminPanel/pages/marcom/myTemplates/MyTemplates.vue"),
    meta: {
      rule: "editor",
    },
  },

  {
    path: "marcom/my-campaign",
    name: "marcom-Mycampaign",
    component: () =>
      import("@/views/adminPanel/pages/marcom/myCampaign/MyCampaign.vue"),
    meta: {
      rule: "editor",
    },
  },

  {
    path: "marcom/calendar",
    name: "marcom-Calendar",
    component: () => import("@/views/adminPanel/pages/addone/Credits.vue"),
    meta: {
      rule: "editor",
    },
  },

  {
    path: "marcom/landing-page",
    name: "marcom-landing-page",
    component: () => import("@/views/adminPanel/pages/landing/Landing.vue"),
    meta: {
      rule: "editor",
    },
  },
  // {
  //   path: "marcom/blog",
  //   name: "marcomblog",
  //   component: () =>
  //     import("@/views/adminPanel/pages/landing/components/Blog1.vue"),
  //   meta: {
  //     rule: "editor",
  //   },
  // },
  // {
  //   path: "marcom/blog2",
  //   name: "marcomblog2",
  //   component: () =>
  //     import("@/views/adminPanel/pages/landing/components/Blog2.vue"),
  //   meta: {
  //     rule: "editor",
  //   },
  // },
  // {
  //   path: "marcom/blog3",
  //   name: "marcomblog3",
  //   component: () =>
  //     import("@/views/adminPanel/pages/landing/components/Blog3.vue"),
  //   meta: {
  //     rule: "editor",
  //   },
  // },
  // {
  //   path: "marcom/blog4",
  //   name: "marcomblog4",
  //   component: () =>
  //     import("@/views/adminPanel/pages/landing/components/Blog4.vue"),
  //   meta: {
  //     rule: "editor",
  //   },
  // },

  {
    path: "marcom/variable",
    name: "marcom-variable",
    component: () => import("@/views/adminPanel/pages/variables/Variable.vue"),
    meta: {
      rule: "editor",
    },
  },

  {
    path: "marcom/landing-page/templates",
    name: "marcom-landing-page-templates",
    component: () =>
      import("@/views/adminPanel/pages/landing/components/Templates.vue"),
    meta: {
      rule: "editor",
    },
  },

  {
    path: "marcom/SMStemplate",
    name: "marcom-SMSTemplate",
    component: () =>
      import(
        "@/views/adminPanel/pages/marcom/components/sms/CreateSmsCampaign.vue"
      ),
    meta: {
      rule: "editor",
    },
  },
  {
    path: "marcom/SMStemplate-complete",
    name: "marcom-SMSTemplate-Complete",
    component: () =>
      import(
        "@/views/adminPanel/pages/marcom/components/sms/components/Done.vue"
      ),
    meta: {
      rule: "editor",
    },
  },

  {
    path: "marcom/template-select",
    name: "marcom-Templateselect",
    component: () =>
      import(
        "@/views/adminPanel/pages/marcom/components/templateSelect/templateSelect.vue"
      ),
    meta: {
      rule: "editor",
    },
  },

  //templatelayout

  {
    path: "marcom/templatelayout-1",
    name: "marcom-Templatelayout1",
    component: () =>
      import(
        "@/views/adminPanel/pages/marcom/components/templateSelect/emaillayout1.vue"
      ),
    meta: {
      rule: "editor",
    },
  },
  {
    path: "marcom/templatelayout-2",
    name: "marcom-Templatelayout2",
    component: () =>
      import(
        "@/views/adminPanel/pages/marcom/components/templateSelect/emaillayout2.vue"
      ),
    meta: {
      rule: "editor",
    },
  },
  {
    path: "marcom/templatelayout-3",
    name: "marcom-Templatelayout3",
    component: () =>
      import(
        "@/views/adminPanel/pages/marcom/components/templateSelect/emaillayout3.vue"
      ),
    meta: {
      rule: "editor",
    },
  },
  {
    path: "marcom/templatelayout-4",
    name: "marcom-Templatelayout4",
    component: () =>
      import(
        "@/views/adminPanel/pages/marcom/components/templateSelect/emaillayout4.vue"
      ),
    meta: {
      rule: "editor",
    },
  },

  {
    path: "marcom/push-notification",
    name: "marcom-Pushnotification",
    component: () =>
      import(
        "@/views/adminPanel/pages/marcom/components/pushNotification/PushNotification.vue"
      ),
    meta: {
      rule: "editor",
    },
  },

  {
    path: "marcom/whatsapp-campaign",
    name: "template-Whatsappcampaign",
    component: () =>
      import(
        "@/views/adminPanel/pages/marcom/components/whatsapp/components/custom-Whatsapp.vue"
      ),
    meta: {
      rule: "editor",
    },
  },

  {
    path: "marcom/pushNotification-template",
    name: "template-Pushnotification",
    component: () =>
      import(
        "@/views/adminPanel/pages/marcom/components/pushNotification/components/custom-notification.vue"
      ),
    meta: {
      rule: "editor",
    },
  },

  {
    path: "marcom/whatsappcampaign-complete",
    name: "marcom-Whatsappcampaign-complete",
    component: () =>
      import(
        "@/views/adminPanel/pages/marcom/components/whatsapp/components/WhDone.vue"
      ),
    meta: {
      rule: "editor",
    },
  },

  {
    path: "marcom/campaign-details",
    name: "marcom-campaignDetails",
    component: () =>
      import("@/views/adminPanel/pages/marcom/components/email/Insights.vue"),
    meta: {
      rule: "editor",
    },
  },
];
